module.exports = __webpack_public_path__ + "img/2_mother.48c36157.jpg";